<template>
  <div
    class="input-dropdown"
    :class="{'is-opened': isOpened}"
    @click.stop
  >
    <div class="input-dropdown__field">
      <div
        class="input-dropdown-field"
        :class="{'is-focus': isFocus}"
      >
        <input type="text"
          :value="value"
          :name="name"
          ref="input"
          @input="onInput"
          @focus="onFocus"
          @blur="onBlur"
          @keyup.enter="onEnter"
          @keyup.esc="onEscape"
        />
      </div>
    </div>
    <div
      v-if="isOpened"
      class="input-dropdown__list"
    >
      <ul class="input-dropdown-list">
        <li
          v-for="(item, index) in filteredList"
          class="input-dropdown-list__item"
          :key="index"
          :tabindex="0"
          @click.prevent="onClickItem(item)"
          @keyup.enter="onClickItem(item)"
          @keyup.esc="onEscape"
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    name () {
      return this.name
    },
    value () {
      return this.value
    }
  },

  props: {
    value: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      default: 'name'
    }
  },

  data () {
    return {
      showList: false,
      isFocus: false
    }
  },

  mounted () {
    document.body.addEventListener('click', this.onClickBody)
  },

  computed: {
    filteredList () {
      return this.list.filter(item => item.indexOf(this.value) !== -1)
    },
    isOpened () {
      return this.showList && this.filteredList.length > 0
    }
  },

  methods: {
    openDropdown () {
      this.showList = true
    },
    closeDropdown () {
      this.showList = false
    },
    onClickBody () {
      this.closeDropdown()
    },
    onClickItem (item) {
      this.$emit('input', item)
      this.$refs.input.focus()
      this.closeDropdown()
    },
    onInput (e) {
      this.$emit('input', e.target.value)
      this.openDropdown()
    },
    onFocus () {
      this.openDropdown()
      this.isFocus = true
      this.$emit('focus')
    },
    onBlur () {
      this.isFocus = false
      this.$emit('blur')
    },
    onEnter (e) {
      this.$emit('enter', e.target.value)
      this.$nextTick(() => {
        this.closeDropdown()
      })
    },
    onEscape () {
      this.closeDropdown()
      this.$refs.input.blur()
    }
  },

  beforeDestroy () {
    document.body.removeEventListener('click', this.onClickBody)
  }
}
</script>
